import React from 'react';
import { getUrl } from 'aws-amplify/storage';
import { useAppContext } from '../contexts/AppContext';

const KeepsakeView = () => {
  const {
    viewingStory, setViewingStory, displayName,
    renderStoryContent, showToast, handleEditStory,
    setActiveTab, audioPlayerRef,
  } = useAppContext();

  if (!viewingStory) return null;
  const story = viewingStory;
  const dateStr = new Date(story.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const isInterview = story.content && story.content.includes('[Memory Interview');
  const audioMatch = story.content && story.content.match(/\[audio:([^\]]+)\]/);
  const storyAudioPath = audioMatch ? audioMatch[1] : null;
  const displayContent = story.content ? story.content.replace(/\n\n\[audio:[^\]]+\]/, '') : '';

  return (
    <div className="keepsake-overlay" onClick={() => setViewingStory(null)}>
      <div className="keepsake-page" onClick={e => e.stopPropagation()}>
        <button className="keepsake-close" onClick={() => setViewingStory(null)}>×</button>
        <div className="keepsake-corner keepsake-corner--tl" />
        <div className="keepsake-corner keepsake-corner--tr" />
        <div className="keepsake-corner keepsake-corner--bl" />
        <div className="keepsake-corner keepsake-corner--br" />

        <div className="keepsake-ornament">✦ ✦ ✦</div>
        <h1 className="keepsake-title">{story.title}</h1>
        <div className="keepsake-meta">{dateStr}</div>
        <div className="keepsake-author">
          {isInterview ? 'A Memory Interview' : `Written by ${displayName || 'the author'}`}
        </div>

        {storyAudioPath && (
          <div style={{ margin: '16px 0', padding: '12px 16px', background: 'rgba(15,23,42,0.04)', border: '1px solid rgba(15,23,42,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '1.1rem' }}>🎙</span>
            <span style={{ color: '#3c4653', fontSize: '1rem', fontStyle: 'italic' }}>Listen to the original voice recording</span>
            <button className="btn btn-secondary" style={{ marginLeft: 'auto', padding: '6px 14px', fontSize: '1rem' }} onClick={async () => {
              try {
                const r = await getUrl({ path: storyAudioPath });
                const url = r.url.toString();
                if (audioPlayerRef.current) { audioPlayerRef.current.pause(); }
                const audio = new Audio(url);
                audioPlayerRef.current = audio;
                audio.play();
              } catch (err) { showToast('Could not play recording.', 'error'); }
            }}>▶ Play</button>
          </div>
        )}

        <div className="keepsake-divider" />
        <div className="keepsake-body">
          {renderStoryContent(displayContent)}
        </div>
        <div className="keepsake-footer-ornament">— ✦ —</div>
        <div className="keepsake-actions">
          <button className="btn btn-blue" onClick={() => { setViewingStory(null); handleEditStory(story); setActiveTab('stories'); }}>Edit</button>
          <button className="btn btn-ghost" onClick={() => setViewingStory(null)}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default KeepsakeView;
